import { z } from 'zod';

export const donorToDoReportSchema = z
  .object({
    startDate: z
      .date({
        required_error: 'Start date is required',
      })
      .transform((d) => d.toISOString()),
    endDate: z
      .date({
        required_error: 'End date is required',
      })
      .transform((d) => d.toISOString()),
    siteIds: z.array(z.string()).min(1, 'At least one site must be selected'),
    donorIds: z.array(z.string()).min(1, 'At least one donor must be selected'),
    clinicIds: z
      .array(z.number())
      .min(1, 'At least one clinic must be selected'),
    accountIds: z
      .array(z.string())
      .min(1, 'At least one account must be selected'),
    yardIds: z.array(z.string()).min(1, 'At least one yard must be selected'),
  })
  .refine((data) => data.startDate <= data.endDate, {
    message: 'Start date must be before or equal to end date',
    path: ['endDate'],
  });

export type DonorToDoReportFormDataInput = z.input<
  typeof donorToDoReportSchema
>;
export type DonorToDoReportFormDataOutput = z.output<
  typeof donorToDoReportSchema
>;
